import { DatePicker, DatePickerProps } from '@progress/kendo-react-dateinputs';
import moment from 'moment-timezone';
import { useCallback } from 'react';

import { CustomCalendar } from 'src/components/custom-cells/CustomCalendar';

interface CustomDateInputProps extends Omit<DatePickerProps, 'onChange' | 'value'> {
  value?: Date | string | null;
  valid: boolean;
  id?: string;
  onChange: (value: Date | null) => void;
  onFocus?: (event: React.FocusEvent<HTMLSpanElement | HTMLDivElement>) => void;
}

const CustomDateInput: React.FC<CustomDateInputProps> = ({
  value,
  id,
  valid,
  onChange,
  ...restProps
}) => {
  const handleBlurChange = useCallback(
    (e: any) => {
      const date: string = e.target.value;
      if (date) {
        if (!date.includes('year') && !date.includes('month') && !date.includes('day')) {
          const momentDate = moment(date, 'MM/DD/YYYY');
          if (momentDate.get('year') < 10) {
            onChange(new Date(momentDate.add(2000, 'years').format()));
          } else {
            onChange(new Date(momentDate.format()));
          }
        } else {
          onChange(null);
        }
      }
    },
    [onChange]
  );

  return (
    <DatePicker
      calendar={CustomCalendar}
      value={value as Date}
      onChange={(e) => onChange(e.value)}
      valid={valid}
      size="small"
      id={id}
      onBlur={handleBlurChange}
      {...restProps}
    />
  );
};

export default CustomDateInput;
